__turbopack_context__.v({
  "btn": "index-module-scss-module__cw99EG__btn",
  "caption": "index-module-scss-module__cw99EG__caption",
  "marginBottom": "index-module-scss-module__cw99EG__marginBottom",
});
